// @flow
const ITEM_TYPE_FILE: 'file' = 'file';
const ITEM_TYPE_FOLDER: 'folder' = 'folder';
const ITEM_TYPE_WEBLINK: 'web_link' = 'web_link';

export { ITEM_TYPE_FILE, ITEM_TYPE_FOLDER, ITEM_TYPE_WEBLINK };
